import { FC } from "react";
import Content from "./content";
import Header from "./header/header";
import styles from "./main-layout.module.css";
import Sidebar from "./sidebar/sidebar";

const MainLayout: FC = () => {
  return (
    <div className={styles.layout}>
      <Header />

      <Sidebar />

      <Content />
    </div>
  );
};

export default MainLayout;
